/* The icons the UI primitives and signed-out pages draw, kept apart from lib/icons: a
   module loads whole, and a sign-in form should not carry every glyph in the app.
   lib/icons re-exports these, so the product still imports one set. */
import {
  ActivityIcon as g_ActivityIcon,
  AlertCircleIcon as g_AlertCircleIcon,
  TriangleAlertIcon as g_TriangleAlertIcon,
  ArrowDownIcon as g_ArrowDownIcon,
  ArrowLeftIcon as g_ArrowLeftIcon,
  ArrowRightIcon as g_ArrowRightIcon,
  ArrowUpIcon as g_ArrowUpIcon,
  BadgeCheckIcon as g_BadgeCheckIcon,
  BanIcon as g_BanIcon,
  BanknoteIcon as g_BanknoteIcon,
  BarChartIcon as g_BarChartIcon,
  BoxesIcon as g_BoxesIcon,
  BrainIcon as g_BrainIcon,
  BriefcaseIcon as g_BriefcaseIcon,
  Building2 as g_Building2,
  CalendarCheckIcon as g_CalendarCheckIcon,
  CalendarClockIcon as g_CalendarClockIcon,
  CheckIcon as g_CheckIcon,
  CheckmarkCircle02Icon as g_CheckmarkCircle02Icon,
  ChevronDownIcon as g_ChevronDownIcon,
  ChevronLeftIcon as g_ChevronLeftIcon,
  ChevronRightIcon as g_ChevronRightIcon,
  ChevronUpIcon as g_ChevronUpIcon,
  CircleIcon as g_CircleIcon,
  ClipboardListIcon as g_ClipboardListIcon,
  ClockIcon as g_ClockIcon,
  CompassIcon as g_CompassIcon,
  CreditCardIcon as g_CreditCardIcon,
  DatabaseIcon as g_DatabaseIcon,
  DollarSignIcon as g_DollarSignIcon,
  DoorOpenIcon as g_DoorOpenIcon,
  DownloadIcon as g_DownloadIcon,
  EyeIcon as g_EyeIcon,
  EyeOffIcon as g_EyeOffIcon,
  FaceIdIcon as g_FaceIdIcon,
  PenTool01Icon as g_PenTool01Icon,
  FileTextIcon as g_FileTextIcon,
  HeadsetIcon as g_HeadsetIcon,
  HeartIcon as g_HeartIcon,
  HeartHandshakeIcon as g_HeartHandshakeIcon,
  HeartPulseIcon as g_HeartPulseIcon,
  HomeIcon as g_HomeIcon,
  InfoIcon as g_InfoIcon,
  KeyRoundIcon as g_KeyRoundIcon,
  LandmarkIcon as g_LandmarkIcon,
  LayersIcon as g_LayersIcon,
  LayoutDashboardIcon as g_LayoutDashboardIcon,
  ListChecksIcon as g_ListChecksIcon,
  Loading03Icon as g_Loading03Icon,
  LockIcon as g_LockIcon,
  MailIcon as g_MailIcon,
  MapPinIcon as g_MapPinIcon,
  MegaphoneIcon as g_MegaphoneIcon,
  MenuIcon as g_MenuIcon,
  MessageSquareIcon as g_MessageSquareIcon,
  MicIcon as g_MicIcon,
  NetworkIcon as g_NetworkIcon,
  PhoneIcon as g_PhoneIcon,
  PhoneCallIcon as g_PhoneCallIcon,
  PillIcon as g_PillIcon,
  PauseIcon as g_PauseIcon,
  PlayCircleIcon as g_PlayCircleIcon,
  PlayIcon as g_PlayIcon,
  PlusIcon as g_PlusIcon,
  ReceiptIcon as g_ReceiptIcon,
  RocketIcon as g_RocketIcon,
  RotateCcwIcon as g_RotateCcwIcon,
  ScrollTextIcon as g_ScrollTextIcon,
  SearchIcon as g_SearchIcon,
  SendIcon as g_SendIcon,
  ServerIcon as g_ServerIcon,
  ShieldAlertIcon as g_ShieldAlertIcon,
  ShieldCheckIcon as g_ShieldCheckIcon,
  SmartphoneIcon as g_SmartphoneIcon,
  SquareIcon as g_SquareIcon,
  StethoscopeIcon as g_StethoscopeIcon,
  TabletsIcon as g_TabletsIcon,
  TrendingUpIcon as g_TrendingUpIcon,
  TruckIcon as g_TruckIcon,
  Unlock as g_Unlock,
  UserCheckIcon as g_UserCheckIcon,
  UserPlusIcon as g_UserPlusIcon,
  UsersIcon as g_UsersIcon,
  VolumeHighIcon as g_VolumeHighIcon,
  WalletIcon as g_WalletIcon,
  WrenchIcon as g_WrenchIcon,
  XIcon as g_XIcon,
  ZapIcon as g_ZapIcon,
  SearchXIcon as g_SearchXIcon,
  CalendarDaysIcon as g_CalendarDaysIcon,
  CameraIcon as g_CameraIcon,
  MoreHorizontalIcon as g_MoreHorizontalIcon,
  PinIcon as g_PinIcon,
  UserIcon as g_UserIcon,
  VideoIcon as g_VideoIcon,
  BellIcon as g_BellIcon,
  LogOutIcon as g_LogOutIcon,
  PanelLeftIcon as g_PanelLeftIcon,
  Image01Icon as g_Image01Icon,
  Share03Icon as g_Share03Icon,
} from "@hugeicons/core-free-icons";
import { icon } from "@/lib/icons/icon";

export { type IconProps, type LucideIcon } from "@/lib/icons/icon";

export const Activity = icon(g_ActivityIcon);
export const AlertCircle = icon(g_AlertCircleIcon);
/* The "!" in a triangle. The package's own AlertTriangle (Alert01) puts the
   dot at the top, an "i" upside down, beside the real one elsewhere. */
export const AlertTriangle = icon(g_TriangleAlertIcon);
export const ArrowDown = icon(g_ArrowDownIcon);
export const ArrowLeft = icon(g_ArrowLeftIcon);
export const ArrowRight = icon(g_ArrowRightIcon);
export const ArrowUp = icon(g_ArrowUpIcon);
export const BadgeCheck = icon(g_BadgeCheckIcon);
export const Ban = icon(g_BanIcon);
export const Banknote = icon(g_BanknoteIcon);
export const BarChart = icon(g_BarChartIcon);
export const Boxes = icon(g_BoxesIcon);
export const Brain = icon(g_BrainIcon);
export const Briefcase = icon(g_BriefcaseIcon);
export const Building2 = icon(g_Building2);
export const CalendarCheck = icon(g_CalendarCheckIcon);
export const CalendarClock = icon(g_CalendarClockIcon);
export const Check = icon(g_CheckIcon);
export const CheckCircle2 = icon(g_CheckmarkCircle02Icon);
export const ChevronDown = icon(g_ChevronDownIcon);
export const ChevronLeft = icon(g_ChevronLeftIcon);
export const ChevronRight = icon(g_ChevronRightIcon);
export const ChevronUp = icon(g_ChevronUpIcon);
export const Circle = icon(g_CircleIcon);
export const ClipboardList = icon(g_ClipboardListIcon);
export const Clock = icon(g_ClockIcon);
export const Compass = icon(g_CompassIcon);
export const CreditCard = icon(g_CreditCardIcon);
export const Database = icon(g_DatabaseIcon);
export const DollarSign = icon(g_DollarSignIcon);
export const DoorOpen = icon(g_DoorOpenIcon);
export const Download = icon(g_DownloadIcon);
export const Eye = icon(g_EyeIcon);
export const EyeOff = icon(g_EyeOffIcon);
export const FaceId = icon(g_FaceIdIcon);
export const FileSignature = icon(g_PenTool01Icon);
export const FileText = icon(g_FileTextIcon);
export const Headset = icon(g_HeadsetIcon);
export const Heart = icon(g_HeartIcon);
export const HeartHandshake = icon(g_HeartHandshakeIcon);
export const HeartPulse = icon(g_HeartPulseIcon);
export const Home = icon(g_HomeIcon);
export const Info = icon(g_InfoIcon);
export const InfoIcon = Info;
export const KeyRound = icon(g_KeyRoundIcon);
export const Landmark = icon(g_LandmarkIcon);
export const Layers = icon(g_LayersIcon);
export const LayoutDashboard = icon(g_LayoutDashboardIcon);
export const ListChecks = icon(g_ListChecksIcon);
export const Loader2 = icon(g_Loading03Icon);
export const Lock = icon(g_LockIcon);
export const Mail = icon(g_MailIcon);
export const MapPin = icon(g_MapPinIcon);
export const Megaphone = icon(g_MegaphoneIcon);
export const Menu = icon(g_MenuIcon);
export const MessageSquare = icon(g_MessageSquareIcon);
export const Mic = icon(g_MicIcon);
export const Network = icon(g_NetworkIcon);
export const Phone = icon(g_PhoneIcon);
export const PhoneCall = icon(g_PhoneCallIcon);
export const Pill = icon(g_PillIcon);
export const Pause = icon(g_PauseIcon);
export const Play = icon(g_PlayIcon);
export const PlayCircle = icon(g_PlayCircleIcon);
export const Plus = icon(g_PlusIcon);
export const Receipt = icon(g_ReceiptIcon);
export const Rocket = icon(g_RocketIcon);
export const RotateCcw = icon(g_RotateCcwIcon);
export const ScrollText = icon(g_ScrollTextIcon);
export const Search = icon(g_SearchIcon);
export const Send = icon(g_SendIcon);
export const Server = icon(g_ServerIcon);
export const ShieldAlert = icon(g_ShieldAlertIcon);
export const ShieldCheck = icon(g_ShieldCheckIcon);
export const Smartphone = icon(g_SmartphoneIcon);
export const Square = icon(g_SquareIcon);
export const Stethoscope = icon(g_StethoscopeIcon);
export const Tablets = icon(g_TabletsIcon);
export const TrendingUp = icon(g_TrendingUpIcon);
export const Truck = icon(g_TruckIcon);
export const Unlock = icon(g_Unlock);
export const UserCheck = icon(g_UserCheckIcon);
export const UserPlus = icon(g_UserPlusIcon);
export const Users = icon(g_UsersIcon);
export const Volume2 = icon(g_VolumeHighIcon);
export const Wallet = icon(g_WalletIcon);
export const Wrench = icon(g_WrenchIcon);
export const X = icon(g_XIcon);
export const Zap = icon(g_ZapIcon);
export const SearchX = icon(g_SearchXIcon);
export const Bell = icon(g_BellIcon);
export const Photos = icon(g_Image01Icon);
export const Share = icon(g_Share03Icon);
export const BellIcon = Bell;
export const CalendarDays = icon(g_CalendarDaysIcon);
export const Camera = icon(g_CameraIcon);
export const MoreHorizontal = icon(g_MoreHorizontalIcon);
export const Pin = icon(g_PinIcon);
export const User = icon(g_UserIcon);
export const Video = icon(g_VideoIcon);
export const LogOut = icon(g_LogOutIcon);
export const PanelLeft = icon(g_PanelLeftIcon);
export const PanelLeftIcon = PanelLeft;
export const CheckIcon = Check;
export const ChevronDownIcon = ChevronDown;
export const ChevronUpIcon = ChevronUp;
export const CircleIcon = Circle;
export const Loader2Icon = Loader2;
export const XIcon = X;
export const ArrowDownIcon = ArrowDown;
